import { atom, selector, useRecoilState } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

const mapProjectionState = atom({
  key: 'mapProjectionState',
  default: selector({
    key: 'mapProjectionStateSelector',
    get: () => {
      return getCustomerSettings('mapConfig.PROJECTION');
    }
  })
});

export const useMapProjectionState = () => {
  const [projection, changeMapProjection] = useRecoilState(mapProjectionState);

  const isMercator = projection === 'mercator';
  const isPolarN = projection === 'polarNorth';
  const isPolarS = projection === 'polarSouth';

  return {
    projection,
    isMercator,
    isPolarN,
    isPolarS,
    changeMapProjection
  }
};